document.addEventListener('DOMContentLoaded', function() {
	// Инициализация слайдера
	jQuery('.products-customer-showcase').slick({
		dots: true,
		arrows: true,
		slidesToShow: 4,
		slidesToScroll: 1,
		infinite: false,
		adaptiveHeight: true,
		draggable: false,
		responsive: [
			{
				breakpoint: 900,
				settings: {
					arrows: false,
					slidesToShow: 2,
					slidesToScroll: 1,
					adaptiveHeight: true,
					draggable: true
				}
			},
			{
				breakpoint: 630,
				settings: {
					infinite: false,
					slidesToShow: 1,
					slidesToScroll: 1,
					arrows: false,
					dots: true,
					centerMode: true,
					centerPadding: '40px',
					draggable: true,
				}
			}
		]
	});

	let currentPopupSlide = 0;
	const uniqueSlides = jQuery('.showcase-slide').filter(function() {
		return !jQuery(this).hasClass('slick-cloned');
	});

	jQuery('.customer-showcase-popup').on('click', '.customer-showcase-popup-prev', function() {
		currentPopupSlide = currentPopupSlide - 1;

		console.log(currentPopupSlide)

		if(currentPopupSlide < 0) {
			currentPopupSlide = uniqueSlides.length - 1;
		}
		uniqueSlides.eq(currentPopupSlide)[0].click();
	});

	jQuery('.customer-showcase-popup').on('click', '.customer-showcase-popup-next', function() {
		currentPopupSlide = currentPopupSlide + 1;

		if(currentPopupSlide >= uniqueSlides.length) {
			currentPopupSlide = 0;
		}
		uniqueSlides.eq(currentPopupSlide)[0].click();
	});
	// Обработчик клика для открытия попапа с использованием делегации событий
	jQuery('.products-customer-showcase-wrapper').on('click', '.showcase-slide', function() {
		const popupContent = jQuery(this).find('.customer-showcase-popup-content').html();
		const popup = jQuery('.customer-showcase-popup .customer-showcase-popup-content');
		popup.html(popupContent);
		jQuery('.customer-showcase-popup').addClass('open');

		jQuery('.customer-showcase-popup .used-products-slider').slick({
			dots: false,
			arrows: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			adaptiveHeight: false,
			draggable: false,
			prevArrow: $('.customer-showcase-popup .used-products-slider-prev'),
			nextArrow: $('.customer-showcase-popup .used-products-slider-next'),
		});

		// Сохранение текущего слайда
		currentPopupSlide = jQuery(this).data('slide-index');
		jQuery('.customer-showcase-popup').data('current-slide', jQuery(this).index());

	});


	jQuery('.used-products-slider-prev').on('click', function() {
		jQuery('.used-products-slider').slick('slickPrev');
	});

	jQuery('.used-products-slider-next').on('click', function() {
		jQuery('.used-products-slider').slick('slickNext');
	});

	// Обработчики для закрытия попапа
	jQuery(document).on('click', '.close-showcase-popup', function() {
		jQuery('.customer-showcase-popup').removeClass('open');
	});

  const slickTrack = document.querySelector('.products-customer-showcase .slick-track');

  if (slickTrack) {
      const slides = slickTrack.querySelectorAll('.slick-slide');
      console.log(slides.length)
      if (slides.length === 1) {
          slickTrack.style.left = '0'; 
          jQuery('.customer-showcase-popup-prev').css('display', 'none')
          jQuery('.customer-showcase-popup-next').css('display', 'none')
            
         
      }
  }
});